import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Search, DoorOpen, HardHat, Building2, CalendarDays } from 'lucide-react';
import { Card, CardContent } from '../Card';
import { Button } from '../Button';
import { SparkleDivider } from '../SparkleDivider';
export function Services() {
  const services = [{
    icon: Sparkles,
    title: 'Standard Clean',
    desc: 'Regular maintenance cleaning to keep your space fresh every week.'
  }, {
    icon: Search,
    title: 'Deep Clean',
    desc: 'A thorough top-to-bottom treatment for move-ins, move-outs, or seasonal resets.'
  }, {
    icon: DoorOpen,
    title: 'Move In / Move Out',
    desc: 'Start fresh or leave spotless. We handle the full transition clean.'
  }, {
    icon: HardHat,
    title: 'Post-Construction',
    desc: 'Dust, debris, and mess cleared so your new space truly shines.'
  }, {
    icon: Building2,
    title: 'Commercial Cleaning',
    desc: 'Offices, studios, and workspaces kept pristine so your team can focus.'
  }, {
    icon: CalendarDays,
    title: 'Recurring Packages',
    desc: 'Weekly, bi-weekly, or monthly. Customized plans that fit your life.'
  }];
  return <section id="services" className="relative py-24 bg-brand-gray overflow-hidden" data-id="element-186">
      {/* Background image */}
      <div className="absolute inset-0 z-0 bg-cover bg-center" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/g5JDX8B3GwfTEjiGNqwzJ9/spacejoy-x3mSC1WnWhc-unsplash.jpg")'
    }} aria-hidden="true" data-id="element-187" />
      {/* Heavy light overlay so the image doesn't compete with the cards */}
      <div className="absolute inset-0 z-[1] bg-brand-white/92 backdrop-blur-sm" data-id="element-188" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-189">
        <SparkleDivider className="mb-12" data-id="element-190" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16 relative" data-id="element-191">
          {/* Soft white glow behind the headline for legibility */}
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[420px] max-w-[90vw] h-40 rounded-full bg-brand-white/90 blur-2xl pointer-events-none" aria-hidden="true" data-id="element-192" />
          <h2 className="relative font-serif text-4xl md:text-5xl text-brand-charcoal drop-shadow-[0_2px_8px_rgba(250,251,255,0.9)]" data-id="element-193">
            What We Do Best
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto mb-16" data-id="element-194">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} data-id="element-195">
              <Card className="bg-white border-none border-t-[3px] border-t-brand-gold rounded-[16px] overflow-hidden h-full transition-all duration-300 hover:scale-[1.03] shadow-[0_4px_24px_rgba(0,0,0,0.08)] hover:shadow-[0_12px_36px_rgba(0,0,0,0.14)]" data-id="element-196">
                <CardContent className="p-9 flex flex-col items-center text-center" data-id="element-197">
                  <div className="w-14 h-14 rounded-full bg-brand-gold/15 flex items-center justify-center mb-6 text-brand-gold" data-id="element-198">
                    <service.icon className="w-7 h-7" data-id="element-199" />
                  </div>
                  <h3 className="font-serif text-xl text-brand-charcoal mb-3" data-id="element-200">
                    {service.title}
                  </h3>
                  <p className="text-brand-charcoal/70 text-sm leading-relaxed" data-id="element-201">
                    {service.desc}
                  </p>
                </CardContent>
              </Card>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-202">
          <Button className="bg-brand-gold hover:bg-brand-gold/90 text-white rounded-full px-8 min-h-[52px] text-lg shadow-soft" data-id="element-203">
            Get a Custom Quote →
          </Button>
        </motion.div>
      </div>
    </section>;
}